import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../static/images/pos-banner.png'
// import imgTop from '../../static/images/pos-banner-top.png'
import product1 from '../../static/images/case-1.png'
// import product2 from '../../static/images/product-2.png'
import product3 from '../../static/images/product-3.png'
import product4 from '../../static/images/product-4.png'
// import product5 from '../../static/images/product-5.png'
// import product6 from '../../../static/images/product-6.png'
// import product7 from '../../../static/images/product-7.png'
// import product8 from '../../../static/images/product-8.png'

import fun1 from '../../static/images/worry-free-1.png'
import fun2 from '../../static/images/worry-free-2.png'
import fun3 from '../../static/images/worry-free-3.png'
import fun4 from '../../static/images/worry-free-4.png'
import fun5 from '../../static/images/worry-free-5.png'
import fun6 from '../../static/images/worry-free-6.png'
import fun7 from '../../static/images/worry-free-7.png'
import fun8 from '../../static/images/worry-free-8.png'

// import memberTop from '../../static/images/member-top.png'
// import member1 from '../../static/images/member1.png'
// import serviceBanner from '../../static/images/case-banner.png'
// import selected from '../../static/images/selete.png'


import './index.less';
// const { TabPane } = Tabs;
class CooperationChannel extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product1, title: '广阔的市场空间', tips: '预计2022年我国新零售行业市场规模将达到1.8万亿，年均复合增长率高达115%，新零售发展潜力无限' },
            { img: product1, title: '强烈的客户需求', tips: '经销商：行业前景不明，推广业务单一，赚不到钱；商家：经营模式单一，营销获客能力弱，综合经营管理能力差。' },
            { img: product1, title: '', tips: '深度结合新零售客户管理需求，提供多产品多业态解决方案，助力企业精细化管理与数字化升级。' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
      componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'cooperation-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                 <iframe 
                 title="cooperation-static"
                 src={`${process.env.PUBLIC_URL}/static/cooperationChannel/cooperationChannel.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container affiliate-container cooperation-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">践行卓越 携手共赢</div>
            //                     <div className="banner-top-title">新机遇 新作为</div>
            //                     <div className="banner-top-title">悦喵AI城市合伙人火热招募中！</div>
                                
            //                 </div>
            //                 {/* <img className="content-right-img" src={imgTop} alt="" /> */}
                            
            //             </div>
                        
            //         </div>
            //     </div>
            //     <div className="common-block-home">
            //         {/* <div className="common-block-home-title">产品功能</div>
            //         <div className="common-block-home-tips">悦喵AI收银系统多端联动</div> */}
            //         <div className="common-block-product">
            //             {
            //                 customerList && customerList.map((item, index) => (
            //                     <div className="common-model" key={index}>
            //                         <div className="common-model-img">
            //                             <img className="img-style" src={item.img} alt="" />
            //                         </div>
            //                         <div className="common-model-title">{item.title}</div>
            //                         <div className="common-model-tips">{item.tips}</div>
            //                     </div>
            //                 ))
            //             }

            //         </div>
            //     </div>


            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">无忧的合作支持加入智汇方象，成为合作伙伴，您将获得</div>
            //         <div className="common-block-product">
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">原店升级</div>
            //                 <div className="product-detail-tips">总部派技术人员对门店进行测量，设计平面图纸，确保无人运营无监控死角</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun2} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">改造施工</div>
            //                 <div className="product-detail-tips">总部提供详细无人店改造方案施工材料从当地采购，由加盟商确定后进行施工</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun3} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">系统指导</div>
            //                 <div className="product-detail-tips">对门店员工及业主进行操作培训指导，内容包括经营管理，店面控制，营销策划</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun4} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">数据分析</div>
            //                 <div className="product-detail-tips">总部运用大数据技术，分析诊断加盟店运营状况，帮助联盟商户及时改进调整</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun5} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">门店运营</div>
            //                 <div className="product-detail-tips">帮助经营定位，商品选购货品摆放，店面布置等实现业绩提升</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun6} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">广告宣传</div>
            //                 <div className="product-detail-tips">由总部统一制定品牌宣传方案线上线下，全媒体立体化强势宣传推广</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun7} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">客服在线</div>
            //                 <div className="product-detail-tips">提供智能云端值守服务，让零售门店做到24小时营业提升业绩，增加利润</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun8} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">后期服务</div>
            //                 <div className="product-detail-tips">总部为提升加盟店与品牌形象，将持续不断地提供经营知道和服务</div>
            //             </div>
                        
            //         </div>

            //     </div>


            //     <div className="common-block-home hardware-page partner-page-content">
            //         <div className="common-block-home-title">无忧的合作支持</div>
            //         <div className="common-block-home-tips">加入悦喵AI，成为合作伙伴，您将获得</div>
            //         <div className="common-block-product">
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">培训支持</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">销售支持</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">技术支持</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">宣传物料支持</div>
            //             </div>
            //         </div>

            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">有效合作四要素</div>
            //         <div className="common-block-product">
            //             <div className="store-model">
            //                 <div className="store-model-title">企业资质
            //                 </div>
            //                 <div className="store-model-index">
            //                 </div>
            //                 <div className="store-model-tips">合法经营执照</div>
            //                 <div className="store-model-tips">独立法人代表</div>
            //                 <div className="store-model-tips">良好商业信誉</div>
            //                 <div className="store-model-right-img">
            //                     <img className="right-img-style" src={product4} alt="" />
            //                 </div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-title">理念认可
            //                 </div>
            //                 <div className="store-model-index">
            //                 </div>
            //                 <div className="store-model-tips">产品价值</div>
            //                 <div className="store-model-tips">文化理念</div>
            //                 <div className="store-model-tips">发展规划</div>
            //                 <div className="store-model-right-img">
            //                     <img className="right-img-style" src={product4} alt="" />
            //                 </div>
            //             </div>
            //             <div className="store-model">
                            
            //                 <div className="store-model-title">销售团队
            //                 </div>
            //                 <div className="store-model-index">
            //                 </div>
            //                 <div className="store-model-tips">规模成熟</div>
            //                 <div className="store-model-tips">服务专业</div>
            //                 <div className="store-model-tips">垂直经验</div>
            //                 <div className="store-model-right-img">
            //                     <img className="right-img-style" src={product4} alt="" />
            //                 </div>
            //             </div>
            //             <div className="store-model">
                           
            //                 <div className="store-model-title">客户资源
            //                 </div>
            //                 <div className="store-model-index">
            //                 </div>
            //                 <div className="store-model-tips">政府资源</div>
            //                 <div className="store-model-tips">银行资源</div>
            //                 <div className="store-model-tips">市场资源</div>
            //                 <div className="store-model-right-img">
            //                     <img className="right-img-style" src={product4} alt="" />
            //                 </div>
            //             </div>
                        
            //         </div>
            //     </div>

            //     <div className="common-block-home apply-common-block-home">
            //         <div className="apply-submit">
            //             <div className="apply-submit-content">
            //                 <div className="apply-submit-title">提交申请</div>
            //                 <div className="apply-submit-tips">在线咨询/表单填写/400电话</div>
            //                 <div className="apply-submit-tips">极速提交合作需求</div>
            //             </div>
            //             <div className="apply-submit-content">
            //                 <div className="apply-submit-title">提交申请</div>
            //                 <div className="apply-submit-tips">在线咨询/表单填写/400电话</div>
            //                 <div className="apply-submit-tips">极速提交合作需求</div>
            //             </div>
            //             <div className="apply-submit-content">
            //                 <div className="apply-submit-title">提交申请</div>
            //                 <div className="apply-submit-tips">在线咨询/表单填写/400电话</div>
            //                 <div className="apply-submit-tips">极速提交合作需求</div>
            //             </div>
            //             <div className="apply-submit-content">
            //                 <div className="apply-submit-title">提交申请</div>
            //                 <div className="apply-submit-tips">在线咨询/表单填写/400电话</div>
            //                 <div className="apply-submit-tips">极速提交合作需求</div>
            //             </div>
            //         </div>
            //         <div className="apply-btn">立即申请</div>
            //         <div className="common-block-home-moblie">合作专线：18561360588</div>
                    
            //     </div>



            // </div >
        )
    }
}


export default CooperationChannel